/* djsamo-page.js — motion for the DJ Samo Academy page (sections/page-djsamo.liquid).
   Ported from djsamo-academy/design/mockup.motion.js: hero entrance, counting stats, staggered
   reveal on scroll, parallax variable, header shrink, progress line. Honors prefers-reduced-motion;
   without JS nothing is hidden (motion rules sit under html.motion / html.ready in djsamo-page.css). */
(function () {
  var root = document.documentElement;
  var app = document.getElementById("app");
  if (!app || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
  root.classList.add("motion");

  // 1. Reveal targets: single items, then groups whose children stagger by index.
  var single = ".sec .eyebrow,.sec h2,.sec .lead,.channel,.incl,.mult,.about blockquote,.final .card,.foot .wrap>div";
  document.querySelectorAll(single).forEach(function (el) { el.classList.add("rv"); });
  document.querySelectorAll(".sec>.wrap").forEach(function (w) {
    Array.prototype.filter.call(w.children, function (c) { return c.matches(".eyebrow,h2,.lead"); })
      .forEach(function (c, i) { c.style.setProperty("--i", i); });
  });
  document.querySelectorAll("[data-stagger]").forEach(function (g) {
    Array.prototype.forEach.call(g.children, function (el, i) { el.classList.add("rv"); el.style.setProperty("--i", i); });
  });
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add("in");
      io.unobserve(el);
      var i = parseFloat(getComputedStyle(el).getPropertyValue("--i")) || 0;
      setTimeout(function () { el.classList.remove("rv", "in"); el.style.removeProperty("--i"); }, 800 + i * 70);
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.1 });
  document.querySelectorAll(".rv").forEach(function (el) { io.observe(el); });

  // 2. Stats count up. The text is the theme-editor value, e.g. "19+", "37.1K", "226K".
  var ease = function (t) { return 1 - Math.pow(1 - t, 3); };
  function countUp(el) {
    var m = /^([\d.,]+)(.*)$/.exec(el.textContent.trim());
    if (!m) return;
    var num = m[1].replace(/,/g, ""), n = parseFloat(num), dec = (num.split(".")[1] || "").length, suf = m[2];
    if (isNaN(n)) return;
    var t0 = performance.now(), dur = 1500;
    (function tick(now) {
      var p = Math.min(1, (now - t0) / dur);
      el.textContent = (n * ease(p)).toFixed(dec) + suf;
      if (p < 1) requestAnimationFrame(tick);
    })(t0);
  }
  var so = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); so.unobserve(e.target); } });
  }, { threshold: 0.6 });
  document.querySelectorAll(".stats b[data-count]").forEach(function (b) { so.observe(b); });

  // 3. Scroll: header state, progress line, parallax variable (--sy in px).
  var top = document.querySelector(".top"), prog = document.querySelector(".prog");
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY, max = root.scrollHeight - window.innerHeight;
      if (top) top.classList.toggle("scrolled", y > 40);
      if (prog) prog.style.transform = "scaleX(" + (max > 0 ? Math.min(1, y / max) : 0) + ")";
      app.style.setProperty("--sy", Math.min(y, 1200));
      ticking = false;
    });
  }
  addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  // 4. Hero entrance once fonts are in (fallback timer so it never stays hidden).
  var started = false;
  var start = function () { if (!started) { started = true; root.classList.add("ready"); } };
  (document.fonts ? document.fonts.ready : Promise.resolve()).then(start);
  setTimeout(start, 1200);
})();
